





























import { Component, Mixins } from 'vue-property-decorator'
import BasePage from '@/tcw/components/BasePage'
import TcwLayoutBasicTemplate from '@/layout/TcwLayoutBasicTemplate.vue'
import MemoInputForm from '@/components/memo/organisms/MemoInputForm.vue'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import DataUpdateComponent from '@/tcw/components/DataUpdateComponent'
import MemoMarkdownForm from '@/components/memo/molecules/MemoMarkdownForm.vue'

@Component({
  components: { TcwLayoutBasicTemplate, MemoInputForm }
})

export default class MemoPage extends Mixins(BasePage) {
  protected get form(): FormStoreComponent {
    return this.$refs.form as FormStoreComponent
  }

  protected save(): void {
    this.form.startSaveProc()
  }

  protected back(): void {
    const form = this.form as any
    if (form.reset instanceof Function) {
      form.reset()
    }
    this.$router.back()
  }
}
